/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react'
import {KTSVG, toAbsoluteUrl} from '../../../../../../_metronic/helpers'
import { propTypes } from 'react-bootstrap/esm/Image';
import { OrgDepartmentAddModal } from './OrgDepartmentAddModal';
import { Link } from 'react-router-dom';

const API_URL_API = process.env.REACT_APP_API_URL_BACKEND


type Props = {
  className : string,
  branch : any,
  getAllDepartments : any
}

const OrgDepartmentTable: React.FC<Props> = ({className, branch, getAllDepartments}) => {

    const [showModal, setShowModal] = useState(false);
    const [data, setData] = useState(null);
    const [edit, setEdit] = useState(false);

    const toggleShow = (departmentId:any)  => {
        

        setEdit(false);
        if(departmentId !== 0){
          setEdit(true);
          branch.departments.map((department:any)=> {
            if(departmentId === department.id){
              setData(department);
            }
          });
        
        }

        setShowModal(pre => !pre);

        if(showModal){
          console.log('toggleShow ' + departmentId);
          getAllDepartments();
        }

    }



    const deleteBranch = async (departmentId:any) => {
      //delete organization
      try
      {
        await fetch(process.env.REACT_APP_API_URL_BACKEND + '/branch/', 
        {
          method: 'DELETE',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({'department_id': departmentId})
        });
        
        getAllDepartments();
      }
      catch(error)
      {
        console.log(error);
      }

    }

  return (
    <>
    <div className={`card ${className}`}>
      {/* begin::Header */}
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-3 mb-1'>{branch.organization.name} - {branch.name} - Departments</span>
        </h3>
        <div className='card-toolbar'>
          <button onClick={() => toggleShow(0)} className='btn btn-sm btn-light-primary'>
            <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-2' />
            Add Department
          </button>
        </div>
      </div>
      {/* end::Header */}
      {/* begin::Body */}
      <div className='card-body py-3'>
        {/* begin::Table container */}
        <div className='table-responsive'>
          {/* begin::Table */}
          <table className='table align-middle gs-0 gy-4'>
            {/* begin::Table head */}
            <thead>
              <tr className='fw-bold text-muted bg-light'>
                <th className='ps-4 min-w-250px rounded-start'>Name</th>
                <th className='ps-4 min-w-200px '>Type</th>
                <th className='ps-4 min-w-200px  '>Status</th>
                <th className='min-w-200px text-end rounded-end'></th>
              </tr>
            </thead>
            {/* end::Table head */}
            {/* begin::Table body */}
            <tbody>
                {branch.departments.map((department:any) => (
                    <tr key={`department-${department.id}`}>
 
                        <td><span className='text-dark fw-bold mb-1 fs-6'>{department.name}</span></td>
                        <td><span className='text-dark fw-bold mb-1 fs-6'>{department.type == 1 ? 'Clinical' : department.type == 2 ? 'Technical' : '' }</span></td>
                        <td><span className='text-dark fw-bold mb-1 fs-6'>{department.status? 'Active':'In-Active'}</span></td>
                        <td className='text-end'>

                            <a href='#' onClick={() => toggleShow(department.id)} className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'>
                            <KTSVG path='/media/icons/duotune/art/art005.svg' className='svg-icon-3' />
                            </a>
                            <a href='#' onClick={() => deleteBranch(department.id)} className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                            <KTSVG path='/media/icons/duotune/general/gen027.svg' className='svg-icon-3' />
                            </a>
                        </td>
                    </tr>
                )
                )}


            </tbody>
            {/* end::Table body */}
          </table>
          {/* end::Table */}
        </div>
        {/* end::Table container */}
      </div>
      {/* begin::Body */}
    </div>
    {
        showModal ? <OrgDepartmentAddModal toggleShow={toggleShow} isUpdate={edit} itemToEdit={data} branchId={branch.id}  /> : null
    }
    </>
  )
}

export {OrgDepartmentTable}
